(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/keno/assets/javascripts/router.js') >= 0) return;  svs.modules.push('/modules/keno/assets/javascripts/router.js');

'use strict';

const playViews = {
  Single: svs.keno.views.PlaySinglePage,
  System: svs.keno.views.PlaySystemPage,
  Package: svs.keno.views.PlayPackagePage
};
const rules = svs.numbergames.rules.getRules({
  productId: svs.numbergames.productMapping.CONSTANTS.KENO
});
svs.keno.Router = Backbone.Router.extend({
  routes: svs.core.data.routes,
  initialize(_ref) {
    let {
      app
    } = _ref;
    svs.keno.logger.debug('svs.keno.Router initialize');
    this.app = app;
  },
  playSingle() {
    svs.keno.logger.debug('svs.keno.Router playSingle');
    this.app.showView(new svs.keno.views.PlaySinglePage());
  },
  playPackageGame(size) {
    svs.keno.logger.debug('svs.keno.Router playPackageGame');
    if (!size) {
      size = rules.defaultPackage;
      Backbone.history.navigate("fardiga-spel/".concat(size), {
        replace: true
      });
    }
    svs.core.data.title = {
      packageSize: size
    };
    svs.core.data.metaDescription = {
      packageSize: size
    };
    this.app.showView(new svs.keno.views.PlayPackagePage({
      size
    }));
  },
  playSystem() {
    svs.keno.logger.debug('svs.keno.Router playSystem');
    this.app.showView(new svs.keno.views.PlaySystemPage());
  },
  playProlongation() {
    svs.keno.logger.debug('svs.keno.Router playProlongation');
    if (!svs.keno.data.prolongWager) {
      svs.keno.logger.warn('svs.keno.Router prolongWager. No wager to prolong.');
      this.navigate('', {
        trigger: true,
        replace: true
      });
    }
    const playedWager = new svs.numbergames.mybets_common_wager.models.Wager(svs.keno.data.prolongWager, {
      parse: true
    });
    const editWagerFunction = svs.numbergames.game.utils.prolongation.getEditWagerFunction({
      playViews,
      modelOptions: {
        hasTickets: svs.keno.data.hasTickets
      }
    });
    editWagerFunction(playedWager);
  },
  fractionGames() {
    svs.keno.logger.debug('svs.keno.Router fractionGames');
    this.app.showView(new svs.keno.views.FractiongamesPage());
  },
  prolongation() {
    svs.keno.logger.debug('svs.keno.Router prolongation');
    const hasSession = svs.numbergames.game_app.utils.handleProlongLogin();
    if (hasSession) {
      this.app.showView(new svs.keno.views.ProlongationPage());
    }
  },
  result(dateString) {
    if (dateString) {
      try {
        const date = dateFns.parseISO(dateString);
        const readableDate = dateFns.format(date, 'd MMMM yyyy', {
          locale: dateFns.locales.sv
        });
        svs.core.data.title = {
          readableDate
        };
        svs.core.data.metaDescription = {
          readableDate
        };
      } catch (e) {
        svs.keno.logger.error('svs.keno.Router result failed to parse date', e);
      }
    }
    svs.keno.logger.debug('svs.keno.Router result');
    this.app.showView(new svs.keno.views.ResultPage({
      dateString
    }));
  }
});

 })(window);